<template>
    <span></span>
</template>

<script>
    export default {}
</script>

<style scoped lang="scss">
    span {
        width: 1px;
        background-color: #ccc;
        display: inline-block;
        height: 100%;
    }
</style>
